// StoreMenuDesktop.js
import React from 'react';
import SectionList from '../shared/SectionList';
import { Search } from "react-feather";

const StoreMenuMobile = ({
  storeMenu,
  menuContent,
  filteredMenuContent,
  searchQuery,
  imageMap,
  navigateToUrl
}) => {
  const sections = (searchQuery ? filteredMenuContent : storeMenu) || [];

  if (searchQuery && sections.length === 0) {
    return (
      <div style={{ padding: "40px 20px", textAlign: "center", color: "#666" }}>
        <Search size={48} style={{ marginBottom: 16, opacity: 0.5 }} />
        <p style={{ margin: 0, fontSize: 16 }}>
          沒有找到與 "{searchQuery}" 相關的結果
        </p>
        <p style={{ margin: "8px 0 0 0", fontSize: 14, opacity: 0.7 }}>
          請嘗試其他關鍵字或清除搜尋
        </p>
      </div>
    );
  }

  return (
    <>
      {sections.map((column, idx) => {
        const resolved = (searchQuery ? filteredMenuContent : menuContent)?.find(c => c.label === column.label);
        return (
          <SectionList
            key={`${column.label}-${idx}`}
            column={column}
            resolved={resolved}
            imageMap={imageMap}
            mode="mobile"
            navigateToUrl={navigateToUrl}
          />
        );
      })}
    </>
  );
};

export default StoreMenuMobile;